import cn from 'classnames';
import styles from './RadioButton.module.scss';

type RadioButtonProps = {
  className?: string;
  checked: boolean;
  onClick: () => void;
};

export function RadioButton({ className, checked, onClick }: RadioButtonProps) {
  const wrapperClassName = cn(
    styles.wrapper,
    {
      [styles.checked]: checked,
    },
    className,
  );

  return (
    <div className={wrapperClassName} onClick={onClick}>
      {checked && <div className={styles.white} />}
    </div>
  );
}
